import { Box, Container } from "@mui/material";
import { Outlet } from "react-router-dom";

import Header from "./Header";
import HideForms from "../../components/SendPulseForms/hide";


const AdminLayout = () => {
    return (
        <>
            <HideForms />
            <Header />
            <Container component="main" sx={{ maxWidth: { lg: "1310px", md: "744px", xs: "364px" } }}>
                <Box sx={{ pb: "50px" }}>
                    <Outlet />
                </Box>
            </Container>
        </>
    );
};

export default AdminLayout;